import React, { useEffect, useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";

// css
import styles from "./addForm.module.scss";
import { FieldArray, Formik } from "formik";
import AppInputField from "components/shared/FormComponents/AppInputField";
import { cloneDeep } from "lodash";
import { successMessageToast } from "helpers/common";
import LoadingIndicator from "components/shared/LoadingIndicator";
import addContentSchema from "./addContent.schema";
import { MIME_TYPES, STATUS_OPTIONS } from "config/constants";
import { RequiredFieldAstrick } from "components/Common/Common";
import { useGetCmsDetailQuery, useUpdateCmsMutation } from "store/services/cms";
import AppFileUploadField from "components/shared/FormComponents/AppFileUploadField";
import { DocumentIcon, MinusIcon, PlusIcon, RemoveIcon } from "Assets/icons";

import { Link } from "react-router-dom";
import { POLICY_AND_PROCEDURE_PREVIEW } from "config/paths";
import CKEditorField from "components/CkEditor/CkEditor";

const PolicyAndProcedure = () => {

  const contentId = 17;

  const [initialValues, setInitialValues] = useState({
    title: "",
    slug: "",
    status: "active",
    seo_title: "",
    seo_keyword: "",
    seo_desc: "",
    cover_img: "",
    videos: [],
    description: "",
    documents: [{
      title: "",
      description: "",
      attachment: {
        attachment_name: "",
        attachment_key: ""
      }
    }]
  });

  const [updateCms, { isLoading: updateCmsLoading }] = useUpdateCmsMutation();
  const { data: teacherDetails, isLoading } = contentId ? useGetCmsDetailQuery(contentId) : {};

  const handleSubmit = async (payload) => {

    try {

      const values = cloneDeep(payload);

      const result = await updateCms({ data: values, contentId });
      if (result?.error) {

        console.error("Error create cms", result.error);
        return;
      };

      successMessageToast(result?.data?.message);
    } catch (err) { console.error("Error create cms", err); }
  };

  const handleAttachDocument = (name, value, setFieldValue) => {
    try {

      const valueSplit = value.split("/");
      const attachment_name = valueSplit[valueSplit?.length - 1];
      setFieldValue(name, { attachment_key: value, attachment_name });
    } catch (err) {
      console.error("Failed to attach document", err);
    }
  };

  useEffect(() => {

    if (!contentId) return;

    if (teacherDetails) {

      setInitialValues({
        ...initialValues,
        title: teacherDetails?.title || "",
        slug: teacherDetails?.slug || "",
        status: teacherDetails?.status || "",
        seo_title: teacherDetails?.seo_title || "",
        seo_keyword: teacherDetails?.seo_keyword || "",
        seo_desc: teacherDetails?.seo_desc || "",
        cover_img: teacherDetails?.cover_img || "",
        videos: teacherDetails?.videos || "",
        description: teacherDetails?.description || "",
        documents: teacherDetails?.type == "policy_procedures" ? teacherDetails?.documents?.length ? teacherDetails?.documents : [singleDocument] : []
      });
    };

  }, [teacherDetails]);

  return (
    <>
      <section className={`${styles.addForm} position-relative py-4 addForm`}>
        <Container fluid={true}>
          <Row>
            <Col lg="12" className="my-2">
              <div className="TableFilter d-flex align-items-center justify-content-between gap-10 flex-wrap">
                <div className="left">
                  <div className="pageHead pb-3 d-flex align-items-center">
                    <h6 className="m-0 fw-bold themeBlue">Policy & Procedures</h6>
                  </div>
                </div>
                <div className="right">
                  <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center justify-content-center flex-wrap gap-10">
                    <li className="">
                      <Link
                        to={POLICY_AND_PROCEDURE_PREVIEW}
                        className="btn text-white d-flex align-items-center justify-content-center commonBtn fw-sbold "
                      >
                        Preview
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>

            </Col>
            {
              isLoading ? <LoadingIndicator /> :
                <Col lg="12" className="my-2">
                  <Formik
                    initialValues={initialValues}
                    validationSchema={addContentSchema}
                    onSubmit={handleSubmit}
                    enableReinitialize
                  >
                    {({
                      handleSubmit,
                      values,
                      setFieldValue,
                      errors
                    }) => (
                      <Form onSubmit={handleSubmit}>
                        <div
                          className="py-3"
                          style={{ borderTop: "1px solid #41a2a84d" }}
                        >
                          <Row>
                            <Col md="6" sm="6" className="my-2">
                              <label
                                htmlFor=""
                                className="form-label themeBlue fw-bold mb-0 d-flex"
                              >
                                Title
                                <RequiredFieldAstrick />
                              </label>
                              <AppInputField
                                type="text"
                                name="title"
                                placeholder="Enter Title"
                                className={`${styles.formControl} form-control`}
                                maxLength={30}
                              />
                            </Col>
                            <Col md="6" sm="6" className="my-2">
                              <label
                                htmlFor=""
                                className="form-label themeBlue fw-bold mb-0 d-flex"
                              >
                                Slug
                              </label>
                              <AppInputField
                                type="text"
                                name="slug"
                                placeholder="Enter Slug"
                                className={`${styles.formControl} form-control`}
                                maxLength={30}
                              />
                            </Col>
                            <Col md="12" sm="12" className="my-2">
                              <label
                                htmlFor=""
                                className="form-label themeBlue fw-bold mb-0 d-flex"
                              >
                                Description
                                <RequiredFieldAstrick />
                              </label>
                              <div className={`ck-editor-wrapper`} >
                                {/* <CKEditor
                                  editor={ClassicEditor}
                                  data={initialValues?.description}
                                  onBlur={(event, editor) => {

                                    setFieldValue("description", editor.getData())
                                  }}
                                /> */}
                                <CKEditorField
                                  handleChange={(event, editor) => setFieldValue("description", editor?.getData())}
                                  value={initialValues?.description}
                                />
                              </div>
                              {errors?.description ? <div className="error">{errors?.description}</div> : null}
                            </Col>
                            <Col md="12" sm="12" className="my-2">
                              <label
                                htmlFor=""
                                className="form-label themeBlue fw-bold mb-1 d-flex my-2"
                                style={{ fontSize: "15px" }}
                              >
                                Policy Procedures
                              </label>
                              <FieldArray name="documents">
                                {({ insert, remove, push }) => (
                                  <ul className="list-unstyled ps-0 mb-0">
                                    {values.documents.length > 0 &&
                                      values.documents.map((area, index) => {
                                        let isLastItem = index === values.documents.length - 1;
                                        return (
                                          <Row className="align-items-center" key={index}>
                                            <Col lg="10">
                                              <Row>
                                                <Col md="8" sm="12" className="my-2">
                                                  <Col md="12" sm="12" className="">
                                                    <label
                                                      htmlFor=""
                                                      className="form-label themeBlue fw-bold mb-0 d-flex"
                                                    >
                                                      Title
                                                      <RequiredFieldAstrick />
                                                    </label>
                                                    <AppInputField
                                                      name={`documents.${index}.title`}
                                                      placeholder="Title"
                                                      className={`${styles.formControl} form-control`}
                                                    />
                                                  </Col>
                                                  <Col md="12" sm="12" className="my-2">
                                                    <label
                                                      htmlFor=""
                                                      className="form-label themeBlue fw-bold mb-0 d-flex"
                                                    >
                                                      Description
                                                      <RequiredFieldAstrick />
                                                    </label>
                                                    <AppInputField
                                                      name={`documents.${index}.description`}
                                                      placeholder="Description"
                                                      fieldType={"textarea"}
                                                      maxLength={500}
                                                      className={`${styles.formControl} form-control`}
                                                    />
                                                  </Col>
                                                </Col>
                                                <Col md="4" sm="12" className="my-2">
                                                  <label
                                                    htmlFor=""
                                                    className="form-label themeBlue fw-bold mb-0 d-flex"
                                                  >
                                                    Document
                                                    <RequiredFieldAstrick />
                                                  </label>
                                                  <AppFileUploadField
                                                    name={`documents.${index}.attachment`}
                                                    acl={"public-read"}
                                                    accept="application/pdf,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation"
                                                    allowedTypes={[MIME_TYPES.pdf, MIME_TYPES.ppt, MIME_TYPES.pptx, MIME_TYPES.pptm]}
                                                    className={`${styles.formControl} form-control`}
                                                    onChange={(name, value) => {
                                                      handleAttachDocument(name, value, setFieldValue);
                                                    }}
                                                  />
                                                  {area?.attachment?.attachment_name ? <div className="left d-flex align-items-center">
                                                    <span className="icn me-2">
                                                      <DocumentIcon />
                                                    </span>
                                                    <p className="m-0 text-muted">{area?.attachment?.attachment_name}</p>
                                                  </div > : null}
                                                </Col>
                                              </Row>
                                            </Col>
                                            <Col lg="2">
                                              <Button
                                                className="border-0 p-0"
                                                variant="transparnet"
                                              >
                                                {isLastItem ? (

                                                  values.documents.length > 1 ? (
                                                    <>
                                                      <PlusIcon onClick={() => push({ ...singleDocument })} />
                                                      <MinusIcon onClick={() => remove(index)} />
                                                    </>
                                                  ) : <PlusIcon onClick={() => push({ ...singleDocument })} />

                                                ) : <MinusIcon onClick={() => remove(index)} />
                                                }
                                              </Button>
                                            </Col>
                                          </Row>
                                        )
                                      })}
                                  </ul>
                                )}
                              </FieldArray>
                            </Col>
                          </Row>
                        </div>
                        <Row className="mt-4">
                          <Col className="my-2" lg="12">
                            <div
                              className={`${styles.btnWrpper} btnWrpper d-flex align-items-center gap-10 pt-3`}
                              style={{ borderTop: "1px solid #41a2a84d" }}
                            >
                              <Button disabled={updateCmsLoading} type="submit" className="d-flex align-items-center justify-content-center commonBtn">
                                {updateCmsLoading ? <LoadingIndicator inline /> : "Save"}

                              </Button>
                            </div>
                          </Col>
                        </Row>
                      </Form>
                    )}
                  </Formik>
                </Col>
            }
          </Row>
        </Container>
      </section>
    </>
  );
};

export default PolicyAndProcedure;

const singleDocument = {
  title: "",
  description: "",
  attachment: {
    attachment_name: "",
    attachment_key: ""
  }
}